import { render, staticRenderFns } from "./AbortoProcessoModal.vue?vue&type=template&id=2da2d456&scoped=true&"
import script from "./AbortoProcessoModal.vue?vue&type=script&lang=js&"
export * from "./AbortoProcessoModal.vue?vue&type=script&lang=js&"
import style0 from "./AbortoProcessoModal.vue?vue&type=style&index=0&id=2da2d456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da2d456",
  null
  
)

export default component.exports